import React from 'react'
import { Image } from 'react-native'
import { PRICE_CHANGE_TILE_ICON } from 'app/assets/images'

interface Props {
  size?: number
}

const BASE_SIZE = 64

const PriceChangeTileImage = ({ size = BASE_SIZE }: Props) => {
  return (
    <Image source={PRICE_CHANGE_TILE_ICON} resizeMode="contain" style={{ width: size, height: size }} />
  )
}

export default PriceChangeTileImage
